#import "../fragments/report-view-fragment.graphql"

query GetRecentlySavedReports {
    recentlySavedReports(limit: 3) {
        ...ReportViewFields
    }
}
